import React, { useState } from 'react';
import { Box, Paper, Tab, Tabs, Typography, Stack, Chip, useMediaQuery, useTheme } from '@mui/material';
import HistoryRoundedIcon from '@mui/icons-material/HistoryRounded';
import LocalCafeRoundedIcon from '@mui/icons-material/LocalCafeRounded';
import DriveFileRenameOutlineRoundedIcon from '@mui/icons-material/DriveFileRenameOutlineRounded';
import MyCreatedOrders from './MyGeneratedDrinks/MyCreatedOrders';
import MyMenuOrders from './MyMenuOrders';
import MyNamedDrinksRequests from './MyGeneratedDrinks/MyNamedDrinksRequests';

const MyOldOrdersPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Box dir="rtl" sx={{ p: { xs: 1.5, sm: 2, md: 3 } }}>
      <Paper
        elevation={0}
        sx={{
          p: { xs: 2, md: 2.5 },
          mb: 2,
          borderRadius: 3,
          border: '1px solid',
          borderColor: 'divider',
          background: 'linear-gradient(145deg, rgba(25,118,210,0.10), rgba(46,125,50,0.08))',
        }}
      >
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          alignItems={{ xs: 'flex-start', md: 'center' }}
          justifyContent="space-between"
          spacing={1.5}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
            <HistoryRoundedIcon sx={{ color: 'primary.main', fontSize: 30 }} />
            <Box>
              <Typography variant="h5" sx={{ fontWeight: 900, fontSize: { xs: '1.2rem', md: '1.5rem' } }}>
                سجل طلباتي
              </Typography>
              <Typography variant="body2" color="text.secondary">
                متابعة الطلبات، مشروباتي، وطلبات التسمية في مكان واحد
              </Typography>
            </Box>
          </Box>

          <Chip
            color="primary"
            variant="outlined"
            label={activeTab === 0 ? 'تبويب الطلبات' : activeTab === 1 ? 'تبويب مشروباتي' : 'تبويب طلبات التسمية'}
          />
        </Stack>
      </Paper>

      <Paper
        elevation={0}
        sx={{
          mb: 3,
          borderRadius: 3,
          border: '1px solid',
          borderColor: 'divider',
          overflow: 'hidden',
        }}
      >
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          dir="rtl"
          variant={isMobile ? 'scrollable' : 'fullWidth'}
          scrollButtons="auto"
          allowScrollButtonsMobile
          sx={{
            minHeight: 56,
            '& .MuiTab-root': {
              minHeight: 56,
              fontWeight: 700,
              fontSize: { xs: 12, sm: 13, md: 14 },
              textTransform: 'none',
            },
          }}
        >
          <Tab icon={<HistoryRoundedIcon fontSize="small" />} iconPosition="start" label="طلباتي" />
          <Tab icon={<LocalCafeRoundedIcon fontSize="small" />} iconPosition="start" label="مشروباتي" />
          <Tab
            icon={<DriveFileRenameOutlineRoundedIcon fontSize="small" />}
            iconPosition="start"
            label="طلبات تسمية مشروباتي"
          />
        </Tabs>
      </Paper>

      {activeTab === 0 && <MyMenuOrders />}
      {activeTab === 1 && <MyCreatedOrders />}
      {activeTab === 2 && <MyNamedDrinksRequests />}
    </Box>
  );
};

export default MyOldOrdersPage;
